import * as React from 'react';

function MoatScore({data} :any) {
  return (
    <div className="col-md-4 stretch-card grid-margin">
      <div className={`card card-img-holder text-white ${data.moat_score_color}`}>
        <div className="card-body">
          <h4 className="font-weight-normal mb-3">Competitive Advantage Score <i className="mdi mdi-chart-line mdi-24px float-right"></i>
          </h4>
          <h2 className="mb-5">{data.moat_score}%</h2>
          <h6 className="card-text">{data.moat_score_meaning}</h6>
        </div>
      </div>
    </div>
  );
}

export default MoatScore;
